import { SET_SUBSCRIPTION, CLEAR_SUBSCRIPTION } from './subscriptionTypes';

const initialState = {
    currentSubscription: null,
};

export default function subscriptionReducer(state = initialState, action) {
    switch (action.type) {
        case SET_SUBSCRIPTION:
            return { ...state, currentSubscription: action.payload };
        case CLEAR_SUBSCRIPTION:
            return initialState;
        default:
            return state;
    }
}
